<template>
  <v-container fluid>
    <div class="mb-4">
      <h2>New Artworkss / Products</h2>
      <p class="text-body-1 font-weight-medium">
        You can send us image(s) in various ways. A single image to be used for different
        products, or multiple images to be produced as a single product
      </p>
    </div>
    <v-card class="my-4">
      <v-card-text>
        <v-row>
          <v-col lg="6" sm="12">
            <v-card>
              <v-card-title>
                Single Image for Multiple Products
              </v-card-title>
              <v-card-text>
                Use this option if you want to produce multiple products using the same
                image. Suitable for Mugs, Cards, Magnets
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click.native="createDialog('Artwork')">
                  Start
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col lg="6" sm="12">
            <v-card>
              <v-card-title>
                Single Product with multiple Images
              </v-card-title>
              <v-card-text>
                Use this option if you want use multiple images for a single product type
                e.g Greeting Card
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click.native="createDialog('Product')">
                  Start
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col lg="6" sm="12">
            <v-card>
              <v-card-title>
                One or more images for Giclee printing
              </v-card-title>
              <v-card-text>
                Use this option if you want to produce Giclee Prints. You can specify
                multiple images and sizes
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click.native="createDialog('Artwork')">
                  Start
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <p class="text-body-1 font-weight-bold mt-4">
          These options require images to be uploaded as jpg/jpeg. It is important to make
          sure these are optimised to ensure the products are of high quality. For
          information and tips about photographing your artwork, please check here. For
          other requriements pelase use or WeTransfer service (below)
        </p>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-text>
        <p class="text-body-1 font-weight-bold">
          If you want to use different image formats, or want to upload files for
          discussion, please use our WeTransfer service
        </p>
      </v-card-text>
      <v-card-actions>
                <v-spacer></v-spacer>
        <v-btn color="success" href="https://yourdoricmor.com/media-upload/">
          WeTransfer
        </v-btn>
      </v-card-actions>
    </v-card>
    <component :is="currentDialog" v-model="openDialog" @close="closeDialog" />
    <!-- <artwork-dialog v-if="openArtworkDialog" v-model="openDialog" @close="closeDialog" />
    <product-dialog v-if="openProductDialog" v-model="openDialog" @close="closeDialog" /> -->
  </v-container>
</template>

<script>
import ArtistApi from "@/api/customer/artist";
import ArtworkDialog from "./components/ArtworkDialog";
import ProductDialog from "./components/ProductDialog";

export default {
  components: {
    ArtworkDialog,
    ProductDialog,
  },
  data() {
    return {
      imageUrl: process.env.VUE_APP_IMG_URL,
      currentDialog: ArtworkDialog,
      openDialog: false,
    };
  },
  async created() { },
  methods: {
    createDialog(dialog) {
      switch (dialog) {
        case "Artwork":
          this.currentDialog = ArtworkDialog;
          break;
        case "Product":
          this.currentDialog = ProductDialog;
      }
      this.openDialog = true;
    },
    closeDialog() {
      this.openDialog = false;
    },
  },
};
</script>
